import React from 'react';
import styles from './LocaleSelector.module.css';
import { Locale } from '../../types';
import { useLocale } from '../../contexts/LocaleContext';
import clsx from 'clsx';

const localeOptions = [
  { value: Locale.en, label: 'English', shortLabel: 'en', flag: '🇬🇧' },
  { value: Locale.ru, label: 'Русский', shortLabel: 'ру', flag: '🇷🇺' },
  { value: Locale.kz, label: 'Қазақша', shortLabel: 'кз', flag: '🇰🇿' }
];

export const LocaleSelector: React.FC = () => {
  const { selectedLocale, setSelectedLocale } = useLocale();

  return (
    <div className={styles.locale_selector}>
      <span className={styles.label}>Language:</span>
      <div className={styles.options}>
        {localeOptions.map((option) => (
          <button
            key={option.value}
            className={clsx(
              styles.option,
              selectedLocale === option.value && styles.selected
            )}
            onClick={() => setSelectedLocale(option.value)}
            title={option.label}
          >
            <span className={styles.text}>{option.label}</span>
            <span className={styles.text_short}>{option.shortLabel}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
